module.exports = __webpack_public_path__ + "static/media/pete_kate_tft.bba15501.jpg";